import { render } from "./MonitoringPublicity.vue?vue&type=template&id=35e7abe6&scoped=true"
import script from "./MonitoringPublicity.vue?vue&type=script&lang=js"
export * from "./MonitoringPublicity.vue?vue&type=script&lang=js"

import "./MonitoringPublicity.vue?vue&type=style&index=0&id=35e7abe6&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e7abe6"]])

export default __exports__